var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(50 296)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.69 300.036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.945,31.374a1.021,1.021,0,0,0-1.02,1.053v14.38H25.691V40.935a1.025,1.025,0,0,0-.983-1.032H19.477a1.047,1.047,0,0,0-1.039,1.032v5.872H11.222V32.9a1,1,0,1,0-2,0V47.859a1.007,1.007,0,0,0,.983,1.016h9.275a1.007,1.007,0,0,0,.983-1.016V41.987h3.227v5.872a1.015,1.015,0,0,0,1.02,1.016h9.238a1.007,1.007,0,0,0,.983-1.016V32.427A1.014,1.014,0,0,0,33.945,31.374Z",
    transform: "translate(-4.231 -15.556)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.517,18.3,27.4,9.96V4.276a1.039,1.039,0,0,0-1.048-1.049,1.017,1.017,0,0,0-.992,1.049v3.6L18.662.987A.975.975,0,0,0,17.97.66a1.006,1.006,0,0,0-.73.326L.422,18.182a1,1,0,0,0,0,1.453.95.95,0,0,0,1.422,0L17.97,3.186l16.089,16.6a.981.981,0,0,0,.73.269,1.115,1.115,0,0,0,.73-.269A1.1,1.1,0,0,0,35.517,18.3Z",
    transform: "translate(-0.109 -0.66)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHouse);
export default __webpack_public_path__ + "static/media/icon_house.dd740235bf67427d05a2aac87ee8e6de.svg";
export { ForwardRef as ReactComponent };